const COOKIE_NAME = 'menu_customer_identity';

function readCookie() {
    const prefix = `${COOKIE_NAME}=`;
    const entry = document.cookie.split('; ').find(cookie => cookie.startsWith(prefix));
    if (!entry) return null;

    try {
        return JSON.parse(decodeURIComponent(entry.slice(prefix.length)));
    } catch (error) {
        return null;
    }
}

export function getCustomerIdentity() {
    const cookieIdentity = readCookie();
    if (cookieIdentity) return cookieIdentity;

    // Migrate an existing identification from the previous per-tab storage.
    try {
        const legacyIdentity = JSON.parse(sessionStorage.getItem(COOKIE_NAME) || 'null');
        if (legacyIdentity) {
            saveCustomerIdentity(legacyIdentity);
            return legacyIdentity;
        }
    } catch (error) {
        sessionStorage.removeItem(COOKIE_NAME);
    }

    return null;
}

export function saveCustomerIdentity(identity) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    // No Expires or Max-Age makes this a browser-session cookie shared by tabs.
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(identity))}; Path=/; SameSite=Lax${secure}`;
    sessionStorage.removeItem(COOKIE_NAME);
}

export function clearCustomerIdentity() {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
    sessionStorage.removeItem(COOKIE_NAME);
}
